import { IconButton, InputAdornment } from "@mui/material";
import Iconify from "src/components/Iconify";

// ----------------------------------------------------------------------

type Props = {
	showPassword: boolean;
	onClick: VoidFunction;
};

export const PasswordAdorment = ({ showPassword, onClick }: Props) => {
	return (
		<InputAdornment position='end'>
			<IconButton edge='end' onClick={onClick}>
				<Iconify icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"} />
			</IconButton>
		</InputAdornment>
	);
};

export default PasswordAdorment;
